import { useEffect } from 'react';
import type { SeoData } from '@/seo/resolve';
import { siteOrigin } from '@/seo/resolve';

const SITE_NAME = 'nomoism.com';

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  const selector = attr === 'name' ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSeo(data: SeoData | null): void {
  useEffect(() => {
    if (!data) {
      document.title = '页面未找到 · NOMOISM';
      return;
    }

    const url = `${siteOrigin()}${data.path}`;

    document.title = data.title;
    upsertMeta('name', 'description', data.description);
    upsertMeta('name', 'keywords', data.keywords);
    upsertLink('canonical', url);

    upsertMeta('property', 'og:title', data.title);
    upsertMeta('property', 'og:description', data.description);
    upsertMeta('property', 'og:type', data.ogType);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:site_name', SITE_NAME);
    upsertMeta('property', 'og:locale', 'zh_CN');
    upsertMeta('property', 'og:image', data.image || '');

    upsertMeta('name', 'twitter:card', data.image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', data.title);
    upsertMeta('name', 'twitter:description', data.description);
    upsertMeta('name', 'twitter:image', data.image || '');
  }, [data]);
}